export const isNonFilterTable = (): boolean => {
    const pathname = window.location.pathname.toLowerCase()
    return (
        pathname.endsWith('salesoverview') ||
        pathname.endsWith('watchedvehicles') ||
        pathname.endsWith('mycontactlogfollowups') ||
        pathname.endsWith('agents')
    )
}
